<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12vJslQ/tc-custom/9781913682835.jpg?1723836046829" alt="This image is the cover for the book Death on Dartmoor, The West County Crime Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death on Dartmoor, The West County Crime Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>In Devon, England, two bodies in a bog send a police detective into the middle of a murky mystery . . .</b><br/><br/> When an amateur archaeologist makes an unusual find, she calls a scholar at a local college. But this discovery—two headless, handless bodies buried in a bog on Dartmoor—doesn’t re-quire a professor but the police. <br/><br/> DI Dan Hellier isn’t sure how he can identify the victims when nobody has reported them miss-ing. And the tension mounts when the death of a young man plunges Hellier into the murky world of the Garrett family. Could the peaceful, family-run Animal Rescue Centre really be a cover for murder and other criminal activity?<br/><br/> Hellier is about to learn just how far people will go to get what they want. And this investiga-tion will challenge Hellier’s decisions as he races to catch a murderer before it’s too late.<br/><br/><i>Previously published as </i>Death and the Good Son<i> by B.A. Steadman.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bernie Steadman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d9cbc2d6